import timeIcon from '@raison/static/icons/time-line.svg';
import {RsnButton, RsnDialog, RsnMessage, styles} from '@raison/ui-kit';
import React from 'react';
import {Link} from 'react-router';
import {AddressStatus} from '~/entities/user';
import {Address} from '../../model/Address';

export interface AddressDialogProps extends Address {
    addressStatus?: AddressStatus;
    navigationReplace?: boolean;
}

export function AddressDialog({
    country,
    postalCode,
    region,
    city,
    streetAddress,
    addressStatus,
    navigationReplace,
}: AddressDialogProps) {
    const footerContent = addressStatus
        ? (() => {
              switch (addressStatus) {
                  case 'success': {
                      return null;
                  }
                  case 'pending': {
                      return (
                          <RsnMessage.FootnoteV2 iconSrc={timeIcon} centered>
                              Your address documents are under review.
                              <br />
                              No action is required right now.
                          </RsnMessage.FootnoteV2>
                      );
                  }
                  default: {
                      return (
                          <RsnButton.Alike
                              as={Link}
                              intent={'primary'}
                              to={'/address-verification'}
                              replace={navigationReplace}
                          >
                              Verify address
                          </RsnButton.Alike>
                      );
                  }
              }
          })()
        : null;

    return (
        <RsnDialog.Window>
            <RsnDialog.LeftHeader>Residential address</RsnDialog.LeftHeader>
            <RsnDialog.Body>
                <div className={'fv-text-m-regular flex flex-col gap-1'}>
                    <div className={cls.row}>
                        <div className={cls.left}>Country</div>
                        <div className={cls.right}>{country ?? '—'}</div>
                    </div>
                    <div className={cls.row}>
                        <div className={cls.left}>ZIP code</div>
                        <div className={cls.right}>{postalCode ?? '—'}</div>
                    </div>
                    <div className={cls.row}>
                        <div className={cls.left}>Region</div>
                        <div className={cls.right}>{region ?? '—'}</div>
                    </div>
                    <div className={cls.row}>
                        <div className={cls.left}>City</div>
                        <div className={cls.right}>{city ?? '—'}</div>
                    </div>
                    <div className={cls.row}>
                        <div className={cls.left}>Address</div>
                        <div className={cls.right}>{streetAddress ?? '—'}</div>
                    </div>
                </div>
            </RsnDialog.Body>
            {footerContent && <RsnDialog.Footer>{footerContent}</RsnDialog.Footer>}
        </RsnDialog.Window>
    );
}

const cls = styles({
    row: 'flex justify-between gap-4',
    left: 'text-nowrap text-left text-neutral-60',
    right: 'text-right text-neutral-100',
});
